import {Box, Typography, useTheme} from "@mui/material";

export default function LoadingContent({title = "Cargando..."}) {
  const theme = useTheme();

  return (
    <Box sx={{height: 400, width: "100%"}}>
      <Typography variant="h4" align="center" color={theme.palette.text.secondary} sx={{mt: 2}}>
        {title}
      </Typography>
    </Box>
  );
}
